import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import * as React from 'react';
import toPath from 'lodash/toPath';
import { clone as cloneDeep } from '@utiljs/clone';
import forOwn from 'lodash/forOwn';
import isNaN from 'lodash/isNaN';
import isEmpty from 'lodash/isEmpty';
import pull from 'lodash/pull';
import { isUndefined, isNull, isString, isObject, isArray } from '@utiljs/is';
export var isValue = function isValue(value) {
  return value !== undefined && value !== null;
};
/**
 * Get Object value or inner value by key path. Support Array and plain object.
 */

export function getValueFromObjOrArray(objOrArray, key) {
  var p = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var obj = objOrArray;

  if (isValue(obj[key])) {
    return obj[key];
  }

  var path = toPath(key);

  while (obj && p < path.length) {
    // eslint-disable-next-line
    obj = obj[path[p++]];
  }

  return obj;
}
/**
 * get value from a tree structure object
 * INFO: Tree use array-like obj to replace array
 * @tree your date
 * @name date key
 * @childrenName tree's children key's name
*/

export var getValueFromTree = function getValueFromTree(tree, name) {
  var childrenName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'fields';

  // immediately hit
  if (tree[name]) {
    return tree[name];
  }

  var l = 1;
  var path = toPath(name);
  var first = tree[path[0]];
  var obj = first;

  if (path.length > 0 && first) {
    while (obj && l < path.length) {
      // tree[path[0]].fields[path[1]].fields[path[2]]
      // eslint-disable-next-line
      obj = obj[childrenName][path[l++]];
    }

    return obj;
  }

  return undefined;
};
export var isEmptyChildren = function isEmptyChildren(children) {
  return React.Children.count(children) === 0;
};
/**
 * Deeply clear object's keys which are null, NaN, undefined。
 * @param obj plain object
 */

export var pruneEmpty = function pruneEmpty(obj, clearFalse) {
  return function prune(current) {
    forOwn(current, function (value, key) {
      if (isUndefined(value) || isNull(value) || isNaN(value) || isString(value) && isEmpty(value) || clearFalse && value === false || isObject(value) && isEmpty(prune(value))) {
        delete current[key];
      }
    }); // remove any leftover undefined values from the delete
    // operation on an array

    if (isArray(current)) {
      pull(current, undefined);
    }

    return current;
  }(cloneDeep(obj));
};
export var setRule = function setRule(name, rules, rule) {
  var paths = toPath(name);
  var length = paths.length;

  var walk = function walk(curRule, index) {
    var key = paths[index];
    var keyNext = paths[index + 1];
    var temp = curRule[key] || {};
    var type = isNaN(+keyNext) ? 'object' : 'array';

    if (!temp.type) {
      temp.type = type;
    }

    if (index < length - 1) {
      if (!temp.fields) {
        temp.fields = {};
      }

      temp.fields[paths[index + 1]] = walk(temp.fields, index + 1);
    } else if (index === length - 1) {
      // temp = {}
      temp = rule;
    }

    return temp;
  };

  if (length < 1) {
    return {};
  }

  if (length === 1) {
    return _Object$assign(_Object$assign({}, rules), _defineProperty({}, paths[0], rules[paths[0]]));
  } else {
    return _Object$assign(_Object$assign({}, rules), _defineProperty({}, paths[0], walk(rules, 0)));
  }
};